import React from 'react'
import { connect } from 'react-redux'

import { View, Row, Column, Intro } from 'components/Layout'
import { Modal, Background } from 'components/Overlay'

import Telescope from '../../assets/intros/telescope.svg'

const PageUnauthorized = ({ user }) => {
	return (
		<View>
			<Background light>
				<Modal>
					<Row>
						<Column width={4} center>
							<Telescope width={180} />
						</Column>
					</Row>
					<Row>
						<Column width={4}>
							<Intro
								center
								header={'Not authorized'}
								body={
									<div>
										<p>
											Apologies! It seems your account:<br />
											<span
												style={{
													display: 'inline-block',
													fontWeight: 'bold',
													margin: '7px auto'
												}}
											>
												{user.login}
											</span>
											<br />doesn't have sufficient
											permissions to operate at Developers
											Console.<br />
											<span
												style={{
													display: 'inline-block',
													fontWeight: 'bold',
													margin: '7px auto'
												}}
											>
												Please contact the owner<br />or
												admin of your license.
											</span>
											<br />
										</p>
									</div>
								}
							/>
						</Column>
					</Row>
				</Modal>
			</Background>
		</View>
	)
}

const mapStateToProps = (state, ownProps) => {
	return {
		user: state.user.meta
	}
}

export default connect(mapStateToProps, null)(PageUnauthorized)



// WEBPACK FOOTER //
// ./src/views/Common/PageUnauthorized.js